<template>
    <el-container>
        <el-main>
            <input type="password" style="outline:none;border:0;width:0;height:0;float:left;background-color: rgba(0, 0, 0, 0);" />
            <el-form :model="formUserInfo" ref="formUserInfo">
                <el-row>
                    <td-button type="button" @click.native="btnEditPassword" style="float:right;">{{ $t('common.CHANGEPASSWORD') }}</td-button>
                </el-row>
                <el-row>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('common.BASE_INFO') }}</span>
                        </div>
                        <el-col :span="8">
                            <el-form-item :label="$t('common.USERNAME')" :label-width="formLabelWidth">
                                {{ this.formUserInfo.sName }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('common.ROLE_INFO')" :label-width="formLabelWidth">
                                {{ this.formUserInfo.roleName }}
                            </el-form-item>
                        </el-col>

                        <el-col :span="8">
                            <el-form-item :label="$t('role.DOOR_ROLE')" :label-width="formLabelWidth">
                                {{ this.formUserInfo.doorRole }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('common.VALIDITY_TO')" :label-width="formLabelWidth">
                                {{ this.formUserInfo.dtLimit }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('common.LOCK_STATE')" :label-width="formLabelWidth">
                                {{ this.formUserInfo.iLockType }}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item :label="$t('userInfo.USER_LEVEL')" :label-width="formLabelWidth">
                                {{ this.formUserInfo.iLevel }}
                            </el-form-item>
                        </el-col>
                    </el-card>
                </el-row>

                <el-row v-if="this.formUserInfo.ipList.length !== 0">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('common.IP_WHITE_LIST') }}</span>
                        </div>
                        <el-col>
                            <el-form-item :label-width="formLabelWidthMore">
                                <el-col v-for="ipStr in this.formUserInfo.ipList" :key="ipStr" :span="3">
                                    {{ ipStr }}
                                </el-col>
                                <!-- {{ this.formUserInfo.ipList }} -->
                            </el-form-item>
                        </el-col>
                    </el-card>
                </el-row>

                <el-row v-if="this.formUserInfo.macList.length !== 0">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('common.MAC_WHITE_LIST') }}</span>
                        </div>
                        <el-col>
                            <el-form-item :label-width="formLabelWidthMore">
                                <el-col v-for="item in this.formUserInfo.macList" :key="item" :span="3">
                                    {{ item }}
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-card>
                </el-row>

                <el-row v-if="this.checkedOrgList.length !== 0">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('common.DEPTMENT') }}</span>
                        </div>
                        <el-col>
                            <el-form-item :label-width="formLabelWidthMore">
                                <el-col v-for="item in this.checkedOrgList" :key="item" :span="3">
                                    {{ item }}
                                </el-col>
                            </el-form-item>
                        </el-col>
                    </el-card>
                </el-row>

                <el-row v-if="this.userPermissions.length !== 0">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ $t('common.AUTH_INFO') }}</span>
                        </div>
                        <el-col v-for="authStr in this.userPermissions" :key="authStr" :span="8">
                            <el-form-item style="margin-bottom:2px;" :label="authStr.split('：')[0] + '：'" :label-width="formLabelWidth">
                                {{ authStr.split('：')[1] }}
                            </el-form-item>
                        </el-col>
                    </el-card>
                </el-row>

                <el-row v-for="(extend, j) in formUserInfo.userExtends" :key="extend.sModuleId">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>{{ extend.sModuleName }}</span>
                        </div>
                        <div v-for="(item, k) in extend.extendList" :key="item.sId">
                            <el-col :span="item.sExtendType === 'checkboxgroup' ? 24 : 8">
                                <el-form-item
                                    :key="item.sId"
                                    :label-width="item.sExtendType === 'checkboxgroup' ? '15%' : formLabelWidth"
                                    :label="item.sName"
                                    :prop="'userExtends.' + j + '.extendList.' + k + '.optionValue'"
                                    :rules="getCheckRule(item)"
                                >
                                    <div v-if="item.sExtendType === 'input'">
                                        <td-input v-model="item.optionValue" :type="item.sParam" :disabled="disableType" placeholder=""></td-input>
                                    </div>
                                    <div v-if="item.sExtendType === 'combobox'" style="height:36px;">
                                        <td-select
                                            v-model="item.optionValue"
                                            :options="item.sParam.split(',')"
                                            :hasBasicTypes="true"
                                            :placeholder="$t('common.PLEASE_SELECT')"
                                            :disabled="disableType"
                                            :filterable="false"
                                        ></td-select>
                                        <!-- <td-select v-model="select" :options="options" ></td-select> -->
                                        <!-- <el-select v-model="item.optionValue" :placeholder="$t('common.PLEASE_SELECT')" :disabled="disableType">
                                        <el-option
                                        v-for="(op,i) in item.sParam.split(',')"
                                        :key="i"
                                        :label="op"
                                        :value="op">
                                        </el-option>
                                    </el-select> -->
                                    </div>
                                    <div v-if="item.sExtendType === 'date'">
                                        <el-date-picker type="date" :placeholder="$t('common.SELECT_DATE')" v-model="item.optionValue" :disabled="disableType"></el-date-picker>
                                    </div>
                                    <div v-if="item.sExtendType === 'radio'">
                                        <el-radio-group v-model="item.optionValue" :disabled="disableType">
                                            <el-radio v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" :value="op"></el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div v-if="item.sExtendType === 'checkbox'">
                                        <td-checkbox v-model="item.optionValue" :label="item.sParam" :disabled="disableType">{{ item.sParam }}</td-checkbox>
                                    </div>
                                    <div v-if="item.sExtendType === 'checkboxgroup'">
                                        <!-- <el-checkbox-group v-model="item.optionValue" :disabled="disableType">
                                            <el-checkbox v-for="(op, i) in item.sParam.split(',')" :key="i" :label="op" style="width:100px;margin:5px 0 0 0;"></el-checkbox>
                                        </el-checkbox-group> -->
                                        <!-- <td-checkbox-group v-model="item.optionValue" :allList="item.sParam.split(',')" :hasBasicTypes="true" :disabled="disableType"></td-checkbox-group> -->
                                        <td-checkbox-group :allList="item.sParam.split(',')" v-model="item.optionValue" :hasBasicTypes="true" :disabled="disableType"></td-checkbox-group>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </div>
                    </el-card>
                </el-row>

                <el-row>
                    <el-col>
                        <el-form-item v-if="!showSave" class="btnStyle">
                            <td-button type="primary" @click.native="btnEdit">{{ $t('common.EDIT') }}</td-button>
                        </el-form-item>
                        <el-form-item v-if="showSave" class="btnStyle">
                            <td-button type="primary" @click="submitForm('formUserInfo')">{{ $t('common.SAVE') }}</td-button>
                            <td-button type="button" @click="editClose()">{{ $t('common.CANCEL') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <dialog-reset-password v-if="dialogResetPasswordVisible" :dialogResetPasswordVisible="dialogResetPasswordVisible" :sysFlg="sysFlg"
                        :editItem="this.formUserInfo" :title="title" ref="addOrModifyInfo" @resetPasswordDialogClose="resetPasswordDialogClose" @reloadPage="reloadPage"></dialog-reset-password> -->
                <dialog-Pwd
                    v-if="dialogResetPasswordVisible"
                    :dialogResetPasswordVisible="dialogResetPasswordVisible"
                    :sSysFlg="sysFlg"
                    :editItem="this.formUserInfo"
                    :title="title"
                    ref="ModifyInfo"
                    @cancelPass="resetPasswordDialogClose"
                ></dialog-Pwd>
            </el-form>
        </el-main>
    </el-container>
</template>

<script>
// import dialogResetPassword from './components/dialogResetPassword.vue'
import dialogModifyPwd from './components/dialogModifyPwd.vue';
import resourceApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        // 'dialog-reset-password': dialogResetPassword
        'dialog-Pwd': dialogModifyPwd
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.sysFlg = this.$common.systemInfo.systemId;
        } else {
            this.sysFlg = 'PG';
        }
        this.formUserInfo.sId = sessionStorage.getItem('userId');
        // 获取当前用户信息
        let param = {
            userId: this.formUserInfo.sId,
            sSysFlg: this.sysFlg,
            currentPage: 1,
            pageSize: 10
        };
        resourceApi.getUserIpList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserIpList', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let arrIp = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                arrIp.push(element.sIp);
            }
            this.formUserInfo.ipList = arrIp;
        });
        resourceApi.getUserMacList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserMacList', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let arrMac = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                arrMac.push(element.sMac);
            }
            this.formUserInfo.macList = arrMac;
        });
        resourceApi.getUserInfos(param, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserInfos', response.data.statusMessage);
                return;
            }
            let userInfo = response.data.content;
            for (let index = 0; index < userInfo.length; index++) {
                const element = userInfo[index];
                this.formUserInfo.sName = element.userName;
                // this.formUserInfo.ipList = element.sIpControl.replace(/#/g, ',')
                this.formUserInfo.dtLimit = this.formatDate(new Date(element.dtLimit * 1), 'yyyy-MM-dd');
                this.formUserInfo.roleName = element.roleName;
                this.formUserInfo.roleList = element.roleId;
                this.formUserInfo.iLevel = element.iLevel;
                if (element.iLockType === 1) {
                    this.formUserInfo.iLockType = this.$t('common.LOCK');
                } else {
                    this.formUserInfo.iLockType = this.$t('common.NORMAL');
                }
                break;
            }
            // 获取权限列表
            let paramAuthInfo = {
                sId: this.formUserInfo.sId,
                roleList: this.formUserInfo.roleList,
                sysID: this.sysFlg
            };

            resourceApi.getUserAuthInfo(JSON.stringify(paramAuthInfo), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserAuthInfo', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                let permissions = [];
                let auths = [];
                for (let index = 0; index < array.length; index++) {
                    permissions.push(array[index].resTypeName);
                    auths.push(array[index].authName);
                }
                let arrAuthStr = [];
                let temp = '';
                for (let index = 0; index < permissions.length; index++) {
                    if (temp.indexOf(permissions[index]) === -1) {
                        if (temp !== '') {
                            arrAuthStr.push(temp);
                        }
                        temp = permissions[index] + '：' + auths[index];
                    } else {
                        temp += '，' + auths[index];
                    }
                }
                if (temp !== '') arrAuthStr.push(temp);
                this.userPermissions = arrAuthStr;
            });
        });
        // 获取所属组织
        let paramOrgInfo = {
            sId: this.formUserInfo.sId,
            sysID: this.sysFlg,
            orgFlg: 1
        };

        resourceApi.getUserRoleInfo(JSON.stringify(paramOrgInfo), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserRoleInfo', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            let orgNames = [];
            for (let index = 0; index < array.length; index++) {
                orgNames.push(array[index].sName);
            }
            this.checkedOrgList = orgNames;
        });
        //门禁权限组
        let doorRoleQueryParam = {
            sId: this.formUserInfo.sId,
            sysFlg: this.sysFlg,
            orgFlg: 2
        };
        resourceApi.getUserRole(JSON.stringify(doorRoleQueryParam), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserRole', response.data.statusMessage);
                return;
            }
            let array = response.data.content;
            if (array.length > 0) {
                this.formUserInfo.doorRole = array[0].sName;
            }
        });
        // 获取用户扩展信息
        resourceApi.getUserExtends({ sysFlg: this.sysFlg }, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserExtends', response.data.statusMessage);
                return;
            }
            let data = response.data.content;
            this.formUserInfo.userExtends = data;

            // 为编辑状态则进行初始化数据
            let content = {
                sId: this.formUserInfo.sId,
                sysFlg: this.sysFlg
            };

            resourceApi.getUserExtendsValues(JSON.stringify(content), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserExtendsValues', response.data.statusMessage);
                    return;
                }

                let values = response.data.content;
                this.lastUserExtends = values;

                let i = 0;
                this.formUserInfo.userExtends.forEach(v => {
                    v.extendList.forEach(val => {
                        if (i >= values.length) {
                            val.sValue = '';
                            this.lastUserExtends.push(val);
                        } else {
                            if (val.sExtendType === 'checkboxgroup') {
                                let arr = values[i].sValue.split('|');
                                val.optionValue = arr;
                            } else if (val.sExtendType === 'checkbox') {
                                let arr = values[i].sValue === 'true';
                                val.optionValue = arr;
                            } else {
                                val.optionValue = values[i].sValue;
                            }
                        }

                        i++;
                    });
                });
            });
        });
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {},
    // 定义数据
    data() {
        return {
            formUserInfo: {
                sId: '',
                sName: '',
                dateTo: '',
                ipList: [],
                macList: [],
                dtLimit: '',
                roleList: '',
                roleName: '',
                doorRole: '',
                iLockType: '',
                userExtends: []
            },
            disableType: true,
            showSave: false,
            editItem: '',
            sysFlg: '',
            // userExtends: [],
            lastUserExtends: [],
            checkedOrgList: [],
            formLabelWidth: '35%',
            formLabelWidthMore: '7%',
            userPermissions: [],
            dialogResetPasswordVisible: false
        };
    },
    // 方法的实现
    methods: {
        getCheckRule(item) {
            var rules = [];
            if (item.iRequired == 1) {
                let requireRules = { required: true, message: this.$t('error.ERROR_INPUT'), trigger: 'change' };
                rules.push(requireRules);
            }
            if (!this.$util.isEmpty(item.sCheckRule)) {
                let otherRules = { pattern: item.sCheckRule, message: item.sCheckTips };
                rules.push(otherRules);
            }
            return rules;
        },
        // 编辑
        btnEdit() {
            this.disableType = false;
            this.showSave = true;
        },
        btnEditPassword() {
            this.title = this.$t('common.EDIT_USER');
            this.dialogResetPasswordVisible = true;
        },
        // 关闭页面
        resetPasswordDialogClose() {
            // this.submit()
            this.dialogResetPasswordVisible = false;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let moduleIds = [];
                    let moduleNames = [];
                    let extendVals = [];
                    let extendIds = [];

                    this.formUserInfo.userExtends.forEach(v => {
                        moduleIds.push(v.sModuleId);
                        moduleNames.push(v.sModuleName);
                        v.extendList.forEach(val => {
                            extendIds.push(val.sId);
                            if (Array.isArray(val.optionValue)) {
                                extendVals.push(val.optionValue.join('|'));
                                let arr = val.optionValue.join('|');
                                val.sValue = arr;
                            } else {
                                extendVals.push(val.optionValue);
                                val.sValue = val.optionValue;
                            }
                        });
                    });

                    let content = {
                        sId: this.formUserInfo.sId,
                        sysFlg: this.sysFlg,
                        extendIds: extendIds.join(','),
                        extendValues: extendVals.join(',')
                    };
                    // 编辑
                    resourceApi.updateUserExtend(JSON.stringify(content), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('user/updateUserExtend', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                        this.lastUserExtends = [];
                        for (let i = 0; i < this.formUserInfo.userExtends.length; i++) {
                            let element = this.formUserInfo.userExtends[i];
                            for (let j = 0; j < element.extendList.length; j++) {
                                this.lastUserExtends.push(element.extendList[j]);
                            }
                        }
                        // this.lastUserExtends = this.$util.clone(this.formUserInfo.userExtends);
                        // this.reloadPage()
                        this.saveExtends();
                    });
                }
            });
        },
        saveExtends() {
            this.showSave = false;
            this.disableType = true;
        },
        editClose() {
            this.initEditData();
        },
        reloadPage() {
            // location.reload()
            this.$message.info(this.$t('message.USERCHANGE'));
        },
        // 初始化编辑数据
        initEditData() {
            let values = this.lastUserExtends;
            let k = 0;
            let userExtendVals = this.formUserInfo.userExtends;
            for (let i = 0; i < userExtendVals.length; i++) {
                let element = userExtendVals[i];
                for (let j = 0; j < element.extendList.length; j++) {
                    if (k >= values.length) {
                        this.showSave = false;
                        this.disableType = true;
                        return;
                    }
                    let val = element.extendList[j];
                    if (val.sExtendType === 'checkboxgroup') {
                        let arr = values[k].sValue.split('|');
                        val.optionValue = arr;
                    } else if (val.sExtendType === 'checkbox') {
                        let arr = values[k].sValue === 'true';

                        val.optionValue = arr;
                    } else {
                        val.optionValue = values[k].sValue;
                    }
                    k++;
                }
            }

            this.showSave = false;
            this.disableType = true;
        },
        formatDate(date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
                }
            }
            return fmt;
        }
    }
};
</script>
<style scoped>
.btnStyle {
    text-align: center;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.el-card {
    padding-bottom: 26px;
}
</style>
